import { render, staticRenderFns } from "./monthlyassess.vue?vue&type=template&id=714b69ee&"
import script from "./monthlyassess.vue?vue&type=script&lang=js&"
export * from "./monthlyassess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports